// extracted by mini-css-extract-plugin
export var addToCartButton = "_q5-b";
export var arrowButtonContainer = "_q5-9";
export var arrowButtonIcon = "_q5-a";
export var carouselArrowButton = "_q5-6";
export var carouselElementContainer = "_q5-1";
export var galleryThumbnail = "_q5-d";
export var galleryThumbnailImage = "_q5-e";
export var left = "_q5-7";
export var productDisplayCarouselContainer = "_q5-0";
export var productTileContainer = "_q5-2";
export var productTileImage = "_q5-4";
export var productTileImageContainer = "_q5-3";
export var productTileTitle = "_q5-5";
export var right = "_q5-8";
export var sliderOverflow = "_q5-c";